
export const cardImages = [
    {
        "Key":"d1",
        "cardSuit":"Diamonds",
        "cardName": "A",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-1.png")
    },
    {
        "Key":"d2",
        "cardSuit":"Diamonds",
        "cardName": "2",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-2.png")
    },
    {
        "Key":"d3",
        "cardSuit":"Diamonds",
        "cardName": "3",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-3.png")
    },
    {
        "Key":"d4",
        "cardSuit":"Diamonds",
        "cardName": "4",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-4.png")
    },
    {
        "Key":"d5",
        "cardSuit":"Diamonds",
        "cardName": "5",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-5.png")
    },
    {
        "Key":"d6",
        "cardSuit":"Diamonds",
        "cardName": "6",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-6.png")
    },
    {
        "Key":"d7",
        "cardSuit":"Diamonds",
        "cardName": "7",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-7.png")
    },
    {
        "Key":"d8",
        "cardSuit":"Diamonds",
        "cardName": "8",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-8.png")
    },
    {
        "Key":"d9",
        "cardSuit":"Diamonds",
        "cardName": "9",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-9.png")
    },
    {
        "Key":"d10",
        "cardSuit":"Diamonds",
        "cardName": "10",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-10.png")
    },
    {
        "Key":"d11",
        "cardSuit":"Diamonds",
        "cardName": "J",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-J.png")
    },
    {
        "Key":"d12",
        "cardSuit":"Diamonds",
        "cardName": "Q",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-Q.png")
    },
    {
        "Key":"d13",
        "cardSuit":"Diamonds",
        "cardName": "K",
        "img":require("../assets/Player_Portal/card-images/Diamonds/Diamonds-K.png")
    },

    {
        "Key":"h1",
        "cardSuit":"Hearts",
        "cardName": "A",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-1.png")
    },
    {
        "Key":"h2",
        "cardSuit":"Hearts",
        "cardName": "2",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-2.png")
    },
    {
        "Key":"h3",
        "cardSuit":"Hearts",
        "cardName": "3",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-3.png")
    },
    {
        "Key":"h4",
        "cardSuit":"Hearts",
        "cardName": "4",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-4.png")
    },
    {
        "Key":"h5",
        "cardSuit":"Hearts",
        "cardName": "5",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-5.png")
    },
    {
        "Key":"h6",
        "cardSuit":"Hearts",
        "cardName": "6",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-6.png")
    },
    {
        "Key":"h7",
        "cardSuit":"Hearts",
        "cardName": "7",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-7.png")
    },
    {
        "Key":"h8",
        "cardSuit":"Hearts",
        "cardName": "8",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-8.png")
    },
    {
        "Key":"h9",
        "cardSuit":"Hearts",
        "cardName": "9",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-9.png")
    },
    {
        "Key":"h10",
        "cardSuit":"Hearts",
        "cardName": "10",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-10.png")
    },
    {
        "Key":"h11",
        "cardSuit":"Hearts",
        "cardName": "J",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-J.png")
    },
    {
        "Key":"h12",
        "cardSuit":"Hearts",
        "cardName": "Q",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-Q.png")
    },
    {
        "Key":"h13",
        "cardSuit":"Hearts",
        "cardName": "K",
        "img":require("../assets/Player_Portal/card-images/Hearts/Heart-K.png")
    },

    {
        "Key":"c1",
        "cardSuit":"Clubs",
        "cardName": "A",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-1.png")
    },
    {
        "Key":"c2",
        "cardSuit":"Clubs",
        "cardName": "2",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-2.png")
    },
    {
        "Key":"c3",
        "cardSuit":"Clubs",
        "cardName": "3",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-3.png")
    },
    {
        "Key":"c4",
        "cardSuit":"Clubs",
        "cardName": "4",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-4.png")
    },
    {
        "Key":"c5",
        "cardSuit":"Clubs",
        "cardName": "5",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-5.png")
    },
    {
        "Key":"6",
        "cardSuit":"Clubs",
        "cardName": "6",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-6.png")
    },
    {
        "Key":"c7",
        "cardSuit":"Clubs",
        "cardName": "7",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-7.png")
    },
    {
        "Key":"c8",
        "cardSuit":"Clubs",
        "cardName": "8",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-8.png")
    },
    {
        "Key":"c9",
        "cardSuit":"Clubs",
        "cardName": "9",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-9.png")
    },
    {
        "Key":"c10",
        "cardSuit":"Clubs",
        "cardName": "10",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-10.png")
    },
    {
        "Key":"c11",
        "cardSuit":"Clubs",
        "cardName": "J",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-J.png")
    },
    {
        "Key":"c12",
        "cardSuit":"Clubs",
        "cardName": "Q",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-Q.png")
    },
    {
        "Key":"c13",
        "cardSuit":"Clubs",
        "cardName": "K",
        "img":require("../assets/Player_Portal/card-images/Clubs/Clubs-K.png")
    },

    {
        "Key":"s1",
        "cardSuit":"Spades   ",
        "cardName": "A",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-1.png")
    },
    {
        "Key":"s2",
        "cardSuit":"Spades   ",
        "cardName": "2",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-2.png")
    },
    {
        "Key":"s3",
        "cardSuit":"Spades   ",
        "cardName": "3",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-3.png")
    },
    {
        "Key":"s4",
        "cardSuit":"Spades   ",
        "cardName": "4",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-4.png")
    },
    {
        "Key":"s5",
        "cardSuit":"Spades   ",
        "cardName": "5",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-5.png")
    },
    {
        "Key":"s6",
        "cardSuit":"Spades   ",
        "cardName": "6",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-6.png")
    },
    {
        "Key":"s7",
        "cardSuit":"Spades   ",
        "cardName": "7",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-7.png")
    },
    {
        "Key":"s8",
        "cardSuit":"Spades   ",
        "cardName": "8",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-8.png")
    },
    {
        "Key":"s9",
        "cardSuit":"Spades   ",
        "cardName": "9",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-9.png")
    },
    {
        "Key":"s10",
        "cardSuit":"Spades   ",
        "cardName": "10",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-10.png")
    },
    {
        "Key":"s11",
        "cardSuit":"Spades   ",
        "cardName": "J",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-J.png")
    },
    {
        "Key":"s12",
        "cardSuit":"Spades   ",
        "cardName": "Q",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-Q.png")
    },
    {
        "Key":"s13",
        "cardSuit":"Spades   ",
        "cardName": "K",
        "img":require("../assets/Player_Portal/card-images/Spades/Spades-K.png")
    },

    // {
    //     "key": 1,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-1.png"),
    // },
    // {
    //     "key": 2,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-2.png")
    // },
    // {
    //     "key": 3,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-3.png"),
    // },
    // {
    //     "key": 4,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-4.png")
    // },
    // {
    //     "key": 5,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-5.png"),
    // },
    // {
    //     "key": 6,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-6.png")
    // },
    // {
    //     "key": 7,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-7.png"),
    // },
    // {
    //     "key": 8,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-8.png")
    // },
    // {
    //     "key": 9,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-9.png"),
    // },
    // {
    //     "key": 10,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-10.png")
    // },
    // {
    //     "key": 11,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-J.png"),
    // },
    // {
    //     "key": 12,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-Q.png")
    // },
    // {
    //     "key": 13,
    //     "cardName": "Clubs",
    //     "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
    //     "front": require("../assets/Player_Portal/card-images/Clubs/Clubs-K.png")
    // }
]




export const cardBackCover = [
    {
        "key": 1,
        "name": "Clubs",
        "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
        "front": require("../assets/Player_Portal/card-images/CardBackCover/CardBackCover.png"),
    },
    {
        "key": 2,
        "name": "Clubs",
        "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
        "front": require("../assets/Player_Portal/card-images/CardBackCover/CardBackCover.png")
    },
    {
        "key": 3,
        "name": "Clubs",
        "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
        "front": require("../assets/Player_Portal/card-images/CardBackCover/CardBackCover.png"),
    },
    {
        "key": 4,
        "name": "Clubs",
        "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
        "front": require("../assets/Player_Portal/card-images/CardBackCover/CardBackCover.png")
    },
    {
        "key": 5,
        "name": "Clubs",
        "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
        "front": require("../assets/Player_Portal/card-images/CardBackCover/CardBackCover.png"),
    },
    {
        "key": 6,
        "name": "Clubs",
        "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
        "front": require("../assets/Player_Portal/card-images/CardBackCover/CardBackCover.png")
    },
    {
        "key": 7,
        "name": "Clubs",
        "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
        "front": require("../assets/Player_Portal/card-images/CardBackCover/CardBackCover.png"),
    },
    {
        "key": 8,
        "name": "Clubs",
        "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
        "front": require("../assets/Player_Portal/card-images/CardBackCover/CardBackCover.png")
    },
    {
        "key": 9,
        "name": "Clubs",
        "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
        "front": require("../assets/Player_Portal/card-images/CardBackCover/CardBackCover.png"),
    },
    {
        "key": 10,
        "name": "Clubs",
        "alt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et",
        "front": require("../assets/Player_Portal/card-images/CardBackCover/CardBackCover.png")
    }
]